import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable react/forbid-elements */
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import * as style from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Preloader = function Preloader(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, mergeStyles(style['preloader'], props.customStyle)), {}, {
    viewBox: "0 0 40 40",
    children: [/*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("linearGradient", {
        id: style['preloader'],
        gradientUnits: "userSpaceOnUse",
        y1: "30",
        x2: "40",
        y2: "30",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0",
          stopColor: "#0076eb"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#fff",
          stopOpacity: "0"
        })]
      })
    }), /*#__PURE__*/_jsx("path", {
      fill: "url(#".concat(style['preloader'], ")"),
      d: "M20,35c-8.3,0-15-6.7-15-15H0c0,11,9,20,20,20c11,0,20-9,20-20h-5C35,28.3,28.3,35,20,35z"
    })]
  }));
};